<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="true"
  [maximizable]="true"
  [baseZIndex]="10000"
  [style]="{ width: '60vw', maxWidth: '900px' }"
  styleClass="status-history-modal-dialog"
  (onHide)="onHide()">
  
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between w-full">
      <h2 class="text-xl font-semibold text-white">
        View Status: {{ ticket?.title || 'Ticket' }}
      </h2>
    </div>
  </ng-template>

  <div class="status-history-container p-6">
    <div class="timeline-wrapper">
      <div class="timeline-line"></div>
      
      <div 
        *ngFor="let history of statusHistory; let i = index; let isLast = last" 
        class="timeline-item"
        [class.last-item]="isLast">
        
        <!-- Timeline Node -->
        <div class="timeline-node" [ngClass]="getStatusIconColor(history.newStatus)">
          <i class="fa-solid" [ngClass]="getStatusIcon(history.newStatus)"></i>
        </div>

        <!-- Status Card -->
        <div class="status-card">
          <div class="status-card-header">
            <div class="user-info">
              <i class="fa-solid fa-user text-gray-500 mr-2"></i>
              <span class="font-semibold text-gray-800">{{ history.userName }}</span>
            </div>
          </div>
          
          <div class="status-transition">
            <div class="status-badge-container">
              <span class="status-badge old-status" [ngClass]="getStatusColor(history.oldStatus)">
                {{ history.oldStatus }}
              </span>
              <i class="fa-solid fa-arrow-right text-gray-400 mx-2"></i>
              <span class="status-badge new-status" [ngClass]="getStatusColor(history.newStatus)">
                {{ history.newStatus }}
              </span>
            </div>
          </div>

          <div class="status-card-footer">
            <i class="fa-solid fa-calendar text-gray-400 mr-2"></i>
            <span class="text-sm text-gray-600">{{ formatDate(history.changedAt) }}</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="statusHistory.length === 0" class="empty-state">
      <i class="fa-solid fa-history text-gray-300 text-4xl mb-4"></i>
      <p class="text-gray-500">No status history available</p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <button
        pButton
        type="button"
        label="Close"
        class="p-button-secondary"
        (click)="onClose()">
      </button>
    </div>
  </ng-template>
</p-dialog>

